export function editableAppraisalInputs(value) {
  if (Array.isArray(value)) return value.map(editableAppraisalInputs)
  if (!value || typeof value !== 'object') return value
  return Object.fromEntries(Object.entries(value)
    .filter(([key]) => !/^(suggested|hmoSuggested|comparableSource|currentMonthlyRent|currentAnnualRent)/.test(key))
    .map(([key, item]) => [key, editableAppraisalInputs(item)]))
}

export function appraisalInputPatch(inputs, previous = {}) {
  const patch = editableAppraisalInputs(inputs)
  for (const [scheme, collection] of [['hmo', 'rooms'], ['commercial', 'units']]) {
    const rows = patch.scheme?.[scheme]?.[collection]
    if (!Array.isArray(rows)) continue
    const ids = new Set(rows.map((row) => String(row.id)))
    for (const row of previous.scheme?.[scheme]?.[collection] ?? []) {
      if (!ids.has(String(row.id))) rows.push({ id: row.id, _destroy: true })
    }
  }
  return patch
}
